import { createFileRoute } from "@tanstack/react-router"
import { MembersPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/members/directory"
)({
  component: () => (
    <AuthorizationGate resource={Resource.MEMBERSHIP} action={Action.READ}>
      <MembersPage />
    </AuthorizationGate>
  ),
})
